export default "__VITE_ASSET__DZ0KCXe6__"